/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'

import React from 'react'

type GrainCanvasProps = {
  zIndex?: number
  opacity?: number
}

export const SuperGrain = ({ zIndex = 0, opacity = 0.4 }: GrainCanvasProps) => {
  const canvasRef = React.useRef<HTMLCanvasElement>(null)

  const canvasStyle = css`
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    pointer-events: none;
    mix-blend-mode: soft-light;
    background: transparent;
    z-index: ${zIndex};
    filter: opacity(${opacity});
  `

  React.useEffect(() => {
    const canvas = canvasRef.current
    if (!canvas) {
      return
    }

    const ctx = canvas.getContext('2d')
    if (!ctx) {
      return
    }

    let width = (canvas.width = window.innerWidth)
    let height = (canvas.height = window.innerHeight)

    const patternSize = 600
    const patternCanvas = document.createElement('canvas')
    patternCanvas.width = patternSize
    patternCanvas.height = patternSize
    const pCtx = patternCanvas.getContext('2d')!

    const imageData = pCtx.createImageData(patternSize, patternSize)
    const buffer = imageData.data
    for (let i = 0; i < buffer.length; i += 4) {
      const val = Math.random() * 40
      buffer[i] = buffer[i + 1] = buffer[i + 2] = val
      buffer[i + 3] = 200
    }
    pCtx.putImageData(imageData, 0, 0)

    const pattern = ctx.createPattern(patternCanvas, 'repeat')

    const draw = () => {
      ctx.clearRect(0, 0, width, height)
      if (pattern) {
        ctx.fillStyle = pattern
        ctx.fillRect(0, 0, width, height)
      }
    }

    draw()

    const handleResize = () => {
      width = canvas.width = window.innerWidth
      height = canvas.height = window.innerHeight
      draw()
    }

    window.addEventListener('resize', handleResize)
    return () => window.removeEventListener('resize', handleResize)
  }, [])

  return <canvas ref={canvasRef} css={canvasStyle} />
}
